import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
//Limitless imports
import { PORTAL_LIST, createPortalURL, isCurrentPortal } from "../utils/PortalHelper";
import { usePortalRoutes } from "../hooks/portal-routes/PortalRoutesHook";
import { useExpertProfileContext } from "../../expert";
const PortalSelectionScreen = ({
  classes,
  history,
  navItems
}) => {
  const {
    canUserAccess
  } = useExpertProfileContext();
  const {
    getAuthorisedDestinationRoute
  } = usePortalRoutes();
  const renderPortal = (portal, index) => {
    if (!canUserAccess(portal.appAccessPolicy)) {
      return null;
    }
    let destinationRoute = null;

    //we can only figure out the correct route if we have nav items
    if (isCurrentPortal(portal)) {
      destinationRoute = getAuthorisedDestinationRoute(navItems);
    } else {
      destinationRoute = portal.destinationRoute;
    }
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 3,
      md: 3,
      key: index
    }, /*#__PURE__*/React.createElement(Card, {
      id: `portalSelection${index}`,
      classes: {
        root: classes.portalCard
      },
      disablefocusripple: "true",
      key: index
    }, /*#__PURE__*/React.createElement(CardActionArea, {
      onClick: () => {
        const url = createPortalURL(portal, null, destinationRoute);
        if (url.includes("http")) {
          window.location = url;
        } else {
          history.push(url);
        }
      }
    }, /*#__PURE__*/React.createElement(CardMedia, {
      className: classes.imageContainer,
      style: {
        backgroundSize: "contain",
        minHeight: 170
      },
      image: portal.imageSource,
      title: portal.title,
      sx: {
        backgroundColor: theme => theme.palette.primary.light
      }
    }), /*#__PURE__*/React.createElement(CardContent, {
      className: classes.content,
      style: {
        minHeight: 107,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      align: "center",
      variant: "h5",
      className: classes.title
    }, portal.title)))));
  };
  const portals = React.useMemo(() => {
    const portalList = [];
    PORTAL_LIST.map((portal, index) => {
      const portalComp = renderPortal(portal, index);
      if (portalComp) {
        portalList.push(portalComp);
      }
    });
    return portalList;
  }, []);
  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    align: "left",
    variant: "h5",
    className: classes.titleContainer
  }, portals.length === 0 ? "Your profile has no access to any portals, please content Limitless support" : "Where do you want to go today?")), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    spacing: 4,
    alignContent: "center",
    alignItems: "center",
    style: {
      margin: "0 15px"
    }
  }, portals));
};
const styles = theme => ({
  portalCard: {
    width: "100%",
    borderRadius: 4,
    maxWidth: 310,
    maxHeight: 310,
    "@media screen and (max-width: 960px)": {
      maxWidth: 200,
      maxHeight: 215
    }
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 170,
    width: "100%",
    backgroundColor: theme.palette.primary.light,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    "@media screen and (max-width: 960px)": {
      height: 125
    }
  },
  image: {
    maxHeight: "100%",
    maxWidth: "100%"
  },
  titleContainer: {
    height: 140,
    justifyContent: "center",
    alignItems: "center",
    display: "flex"
  },
  title: {
    color: theme.palette.primary.dark
  },
  content: {
    height: 107,
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    "@media screen and (max-width: 960px)": {
      height: 60
    }
  }
});
export default withRouter(withStyles(styles)(PortalSelectionScreen));
PortalSelectionScreen.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  navItems: PropTypes.array.isRequired
};